import { useContent } from "hooks/useContent";
import SectionIntro from "./SectionIntro";
import FDIInflows from "./FDIInflows";
import InfographicsSection from "./InfographicsSection";
import FDICardsSection from "./FDICardsSection";
import FDIProjectsSection from "./FDIProjectsSection";
import KeyOutcomesSlider from "../sliders/KeyOutcomesSlider";
import FDITrends from "./FDITrends";

interface FDIOutlookProps {
}

const FDIOutlook: React.FC<FDIOutlookProps> = ({ }) => {
     const { content } = useContent();

    return (
        <section id="fdi-outlook">
            <SectionIntro data={content.sectionIntro} />
            <FDIInflows data={content.fdiInflows} />
            <InfographicsSection data={content.infographicsSection} />
            <FDICardsSection cards={content.fdiCardsSection.cards} />
            <FDIProjectsSection data={content.fdiProjectsSection} />
            <KeyOutcomesSlider slides={content.keyOutcomes.slides} />
            <FDITrends data={content.fdiTrends} />
        </section>
    );
};

export default FDIOutlook;
